import { createUseStyles } from 'react-jss'

export default createUseStyles({
  tooltip: {
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: 'white',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 400,
    pointerEvents: 'none',
    zIndex: 10000,
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    transition: 'opacity 150ms ease 100ms, transform 150ms ease 100ms'
  },
  title: {
    fontWeight: 600,
    marginBottom: '4px'
  }
})

// Helper function to get dynamic styles based on props
export const getDynamicTooltipStyles = ({ x, y, offsetX, offsetY, isVisible, hasTooltip }) => ({
  left: x + offsetX,
  top: y + offsetY,
  opacity: isVisible ? 1 : 0,
  transform: isVisible ? 'scale(1) translateY(0px)' : 'scale(0.8) translateY(8px)',
  visibility: hasTooltip ? 'visible' : 'hidden'
})
